<template>
  <div class="my-order">
    <div class="account-card">
      <div class="account-card-header">
        <p class="account-card-title">我的保证金</p>
      </div>
      <!--搜索条件开始-->
      <el-form
        size="mini"
        class="order-form"
        :inline="true"
        :model="form"
        ref="ruleForm"
        label-width="110px"
        label-position="right"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item class="form-item-box" label="公告编号：" prop="code">
              <el-input v-model="form.code" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="form-item-box" label="公告标题：" prop="title">
              <el-input v-model="form.title" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="公告发布单位："
              prop="publicCompName"
            >
              <el-input
                v-model="form.publicCompName"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item
              class="form-item-box"
              label="状态："
              prop="scheduleCode"
            >
              <el-select v-model="form.scheduleCode">
                <el-option
                  v-for="item in statusList"
                  :key="item.statusCode"
                  :label="item.label"
                  :value="item.statusCode"
                  >{{ item.label }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              class="form-item-date"
              prop="payEndTime"
              label="截止支付日期："
              label-width="110px"
            >
              <el-date-picker
                type="date"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                v-model="form.payEndTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button size="mini" type="primary" @click="onSubmit('ruleForm')"
              >搜索</el-button
            >
            <el-button size="mini" type="plain" @click="resetForm('ruleForm')"
              >清空</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <!--搜索条件结束-->
    </div>
    <!--结果表格开始-->
    <div class="my-order-body">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="公告编号"
          :show-overflow-tooltip="true"
          width="140"
          header-align="center"
          align="center"
        >
          <template v-slot="scope">
            <span class="cell-link" @click="toDetail(scope.row)">
              {{ scope.row.notice.code }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="公告标题"
          width="160"
          :show-overflow-tooltip="true"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.notice.title }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="公告发布单位"
          width="150"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.notice.publicCompName }}
          </template>
        </el-table-column>
        <el-table-column
          width="140"
          label="保证金金额（元）"
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.notice.depositPrice }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payEndTime"
          label="截止支付时间"
          width="140"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusCode"
          label="状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ checkStatus(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="scheduleCode"
          label="操作"
          header-align="center"
          align="center"
          width="120px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-link type="primary" @click="onOperation(scope.row)">
              {{ checkOperateType(scope.row) }}
            </el-link>
            <el-link
              style="margin-left:10px"
              type="primary"
              @click="onReturnDeposit(scope.row)"
              v-if="scope.row.revokeRefundWhether == 1"
            >
              退还保证金
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="notice-pagination">
        <el-col :offset="7" :span="12">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout=" pager, next,total, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.pageIndex"
            :total="pagination.total"
          >
            到第{{ pagination.pageIndex }}页
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <ReturnDepositDialog
      :show.sync="showVisible"
      :clickRow="clickRow"
      @success="onSuccess"
    />
    <!--结果表格结束-->
  </div>
</template>

<script>
import ReturnDepositDialog from './ReturnDepositDialog.vue'

export default {
  name: 'MyDeposit',
  components: { ReturnDepositDialog },
  directives: {},
  filters: {},
  mixins: {},
  data() {
    return {
      clickRow: {},
      showVisible: false,
      paramsobj: {},
      pageType: '',
      statusList: [
        { label: '待支付', statusCode: '010' },
        { label: '已支付', statusCode: '020' },
        { label: '已过期', statusCode: '030' },
        { label: '已退款', statusCode: '040' },
        { label: '罚没', statusCode: '050' },
        { label: '待补交保证金', statusCode: '060' },
        { label: '已补交保证金', statusCode: '070' },
        { label: '结算中', statusCode: '080' },
        { label: '待补交服务费', statusCode: '090' },
        { label: '已结算', statusCode: '100' }
      ],
      form: {
        title: null,
        code: null,
        disposerCompName: null,
        dealDateStart: null,
        dealDateEnd: null,
        noticeTitle: null,
        scheduleCode: null
      },
      tableData: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.$route.query.type == 1) {
      this.form.scheduleCode = '060'
    }
    let params = {
      pageSize: this.pagination.pageSize,
      pageIndex: this.pagination.pageIndex,
      scheduleCode: this.$route.query.type == 1 ? '060' : null
    }
    this.getTableData(params)
  },
  methods: {
    checkOperateType(row) {
      if (row.scheduleCode == '010') {
        return '去支付'
      } else if (row.scheduleCode == '060') {
        return '补交保证金'
      } else if (row.scheduleCode == '090') {
        return '补交服务费'
      } else if (row.scheduleCode == '080') {
        return '结算中'
      } else {
        return '查看'
      }
    },
    /*
    010待支付 020已支付
    030已过期 040已退款
    050 罚没 060待补交保证金
    070已补交保证金 080结算中
    090待补交服务费 100已结算
    */
    checkStatus(row) {
      let result = ''
      if (row.scheduleCode == '010') {
        result = '待支付'
      } else if (row.scheduleCode == '020') {
        result = '已支付'
      } else if (row.scheduleCode == '030') {
        result = '已过期'
      } else if (row.scheduleCode == '040') {
        result = '已退款'
      } else if (row.scheduleCode == '050') {
        result = '罚没'
      } else if (row.scheduleCode == '060') {
        result = '待补交保证金'
      } else if (row.scheduleCode == '070') {
        result = '已补交保证金'
      } else if (row.scheduleCode == '080') {
        result = '结算中'
      } else if (row.scheduleCode == '090') {
        result = '待补交服务费'
      } else {
        result = '已结算'
      }
      return result
    },
    //获取列表数据
    async getTableData(params) {
      this.paramsobj = params

      this.tableData = await this.$api.depositPrice.getDepositorderList(
        this.paramsobj
      )
      this.pagination.total = this.tableData.total || 0
      this.tableData = this.tableData.data || []
    },
    toDetail(row) {
      this.$router.push({
        name: 'NoticeInfo',
        query: {
          id: row.noticeId
        }
      })
    },
    //点击搜索
    async onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {}
          Object.keys(this.form).forEach(item => {
            if (
              this.form[item] ||
              this.form[item] === 0 ||
              this.form[item] === '0'
            )
              obj[item] = this.form[item]
          })
          let param = { ...obj, pageIndex: 1, pageSize: 10 }
          this.getTableData(param)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //点击清空
    async resetForm(formName) {
      let params = {
        pageSize: this.pagination.pageSize,
        pageIndex: this.pagination.pageIndex
      }
      this.getTableData(params)
      this.$nextTick(() => {
        this.form.scheduleCode = ''
      })
      console.log(this.form)
      this.$refs[formName].resetFields()
    },
    handleSizeChange(val) {
      let obj = {}
      Object.keys(this.form).forEach(item => {
        if (this.form[item] || this.form[item] === 0 || this.form[item] === '0')
          obj[item] = this.form[item]
      })
      let param = { ...obj, pageIndex: 1, pageSize: val }
      this.getTableData(param)
    },
    handleCurrentChange(val) {
      let obj = {}
      Object.keys(this.form).forEach(item => {
        if (this.form[item] || this.form[item] === 0 || this.form[item] === '0')
          obj[item] = this.form[item]
      })
      let param = { ...obj, pageIndex: val, pageSize: 10 }
      this.getTableData(param)
    },
    onOperation(row) {
      /*
      pageType 查看check 支付pay 补交 payLater
      */
      this.$router.push({
        name: 'MyDepositOperate',
        query: {
          id: row.id,
          noticeId: row.noticeId,
          depositId: row.depositId
        }
      })
    },
    onReturnDeposit(row) {
      this.$confirm(
        '退还保证金将导致您无法参与竞价，是否确认退还保证金?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.clickRow = row
          this.showVisible = true
        })
        .catch(() => {})
    },
    onSuccess(val) {
      if (val) {
        this.getTableData(this.paramsobj)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.my-order {
  margin-bottom: 30px;
  .account-card {
    .order-form {
      padding: 15px 34px;
      .el-form-item.el-form-item--mini {
        display: flex !important;
        // width: 90%;
      }
      .el-button {
        font-size: 15px;
        padding: 8px 15px;
      }
    }
  }
}
</style>
